import { Box, Button, Container, Divider, Paper, Stack, Typography, useTheme } from '@mui/material';
import TermsCheckbox from '../../components/TermsCheckbox';
import AnimationPage from '../AnimationPage';
import { useEffect, useState } from 'react';
import BreadCrumb from '../../components/bread-crumb';
import { Link, useNavigate } from 'react-router-dom';
import TermCondition1 from './TermCondition1';
import TermCondition2 from './TermCondition2';
import TermCondition3 from './TermCondition3';
import CloseIcon from '@mui/icons-material/Close';
import Modal from '@mui/material/Modal';

const initialTermsAll = {
  term1: true,
  term2: true,
  term3: true,
};

const initialTerms = {
  term1: false,
  term2: false,
  term3: false,
};

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '800px',
  maxHeight: '800px',
  bgcolor: 'background.paper',
  border: '2px solid #0F7F85',
  padding: '20px',
  boxShadow: 24,
  p: 4,
  overflow: 'auto',
};

export default function SectionOne({ section, setSection }) {
  const theme = useTheme();
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);

  const [terms, setTerms] = useState(initialTerms);
  const [all, setAll] = useState(false);
  const [termNumber, setTermNumber] = useState(null);

  const validation = () => {
    if (all) {
      return false;
    } else if (terms.term1 && terms.term2) {
      return false;
    }
    return true;
  };

  const handleClose = () => {
    setOpen(!open);
  };

  useEffect(() => {
    if (terms.term1 && terms.term2 && terms.term3) {
      setAll(true);
    } else {
      setAll(false);
    }
  }, [terms]);

  useEffect(() => {
    if (!all && !terms.term1 && !terms.term2 && !terms.term3) {
      setTerms(initialTerms);
    }
  }, [all]);
  return (
    <AnimationPage>
      <Box
        sx={{
          mt: 6,
          ml: 7,
        }}>
        <img src="/images/logo/logoo.svg" alt="logo" />

        <Container maxWidth="lg" sx={{ mt: 13.5 }}>
          {/* <BreadCrumb crumbName={'대표자 정보 입력'} section={section} setSection={setSection} /> */}
          <Paper
            sx={{
              color: theme.palette.info.main,
              boxShadow: '0px 0px 7px #0000001A',
              borderRadius: '10px',
              elevation: 3,
              py: 6,
              px: 7.5,
            }}>
            <Typography
              sx={{
                fontSize: '30px',
                lineHeight: '34px',
                fontWeight: 'bold',
              }}>
              안녕하세요 바디스위치 입니다.
            </Typography>
            <Box sx={{ display: 'flex', mt: 4 }}>
              <Typography
                sx={{
                  textAlign: 'center',
                  alignContent: 'center',
                  fontSize: '30px',
                  lineHeight: '34px',
                  fontWeight: 'bold',
                  bgcolor: '#D9D9D9',
                  width: 707,
                  height: 395,
                }}>
                <div
                  alt="spinning lady"
                  style={{
                    backgroundImage: 'url("/images/Screen-2.png")',
                    height: '395px',
                    width: '650px',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    // filter: 'grayscale(100%)',
                  }}></div>
              </Typography>
              <Box sx={{ ml: 8 }}>
                <Typography sx={{ fontWeight: 'bold', fontSize: '17px' }}>이용약관 및 개인 정보 취급 동의</Typography>

                <Box sx={{ display: 'flex', alignItems: 'flex-start', mt: 4 }}>
                  <TermsCheckbox
                    sx={{ padding: '20px' }}
                    id="all"
                    checked={all}
                    disabled={Object.values(terms).every(term => term)}
                    onChange={() => {
                      setAll(!all);
                    }}
                    onClick={() => {
                      !all ? setTerms(initialTermsAll) : setTerms(initialTerms);
                    }}
                  />
                  <Stack ml="6px">
                    <Typography sx={{ color: '#5A5A5A', fontSize: '15px', fontWeight: 500 }}>
                      이용약관 전체 동의
                    </Typography>
                    <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#98A6AD', mt: 1.2 }}>
                      선택 항목이 포함되어 있으며 동의하지 않아도 회원가입이 가능합니다.
                    </Typography>
                  </Stack>
                </Box>
                <Divider sx={{ border: '1px solid #e1e1e1', my: 2.5 }} />
                <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
                  <TermsCheckbox
                    id="term1"
                    checked={terms.term1}
                    onChange={() => setTerms({ ...terms, term1: !terms.term1 })}
                  />
                  <Stack
                    ml="6px"
                    sx={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                    <Typography sx={{ color: '#5A5A5A', fontSize: '14.62px', fontWeight: 500 }}>
                      회원 약관 동의(필수)
                    </Typography>
                    <Button
                      size="large"
                      variant="text"
                      sx={{
                        fontSize: '11px',
                        color: '#98A6AD',
                        textDecoration: 'underline',
                      }}
                      onClick={() => {
                        setOpen(true);
                        setTermNumber(1);
                      }}>
                      상세보기
                    </Button>
                  </Stack>
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'baseline', my: 3.65 }}>
                  <TermsCheckbox
                    id="term2"
                    checked={terms.term2}
                    onChange={() => setTerms({ ...terms, term2: !terms.term2 })}
                  />
                  <Stack
                    ml="6px"
                    sx={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                    <Typography sx={{ color: '#5A5A5A', fontSize: '14.62px', fontWeight: 500 }}>
                      개인정보 수집 및 이용에 대한 동의(필수)
                    </Typography>
                    <Button
                      size="large"
                      variant="text"
                      sx={{
                        fontSize: '11px',
                        color: '#98A6AD',
                        textDecoration: 'underline',
                      }}
                      onClick={() => {
                        setOpen(true);
                        setTermNumber(2);
                      }}>
                      상세보기
                    </Button>
                  </Stack>
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
                  <TermsCheckbox
                    id="term3"
                    checked={terms.term3}
                    onChange={() => setTerms({ ...terms, term3: !terms.term3 })}
                  />
                  <Stack
                    ml="6px"
                    sx={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                    <Typography sx={{ color: '#5A5A5A', fontSize: '14.62px', fontWeight: 500 }}>
                      이벤트 마케팅 수신동의(선택)
                    </Typography>
                    <Button
                      size="large"
                      variant="text"
                      sx={{
                        fontSize: '11px',
                        color: '#98A6AD',
                        textDecoration: 'underline',
                      }}
                      onClick={() => {
                        setOpen(true);
                        setTermNumber(3);
                      }}>
                      상세보기
                    </Button>
                  </Stack>
                </Box>
              </Box>
            </Box>

            <Divider sx={{ border: '1px solid #E7E7E7', mt: 5.2, mb: 3 }} />

            <Stack sx={{ flexDirection: 'row', justifyContent: 'end' }}>
              <Button
                variant="contained"
                color="secondary"
                sx={{
                  color: '#fff',
                  borderRadius: '5px',
                  height: 40,
                  minWidth: 125,
                  boxShadow: 'none',
                  mr: 1,
                }}
                onClick={() => navigate('/login')}
                // disabled={isSaving}
                // onClick={onCancel}
              >
                뒤로가기
              </Button>
              <Button
                variant="contained"
                color="primary"
                sx={{ borderRadius: '5px', minWidth: 183 }}
                // disabled={isSaving}
                disabled={validation()}
                onClick={() => setSection(2)}>
                다음
              </Button>
            </Stack>
          </Paper>
        </Container>
      </Box>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box sx={{ padding: '20px' }}>
          <Box
            sx={{
              position: 'fixed',
              right: '25px',
              padding: '5px',
              borderRadius: '50%',
              background: '#fff',
              '&:hover': {
                cursor: 'pointer',
              },
            }}
            onClick={() => setOpen(false)}>
            <CloseIcon />
          </Box>
          <Box sx={style}>
            {termNumber === 1 && <TermCondition3 />}
            {termNumber === 2 && <TermCondition2 />}
            {termNumber === 3 && <TermCondition1 />}
          </Box>
        </Box>
      </Modal>
    </AnimationPage>
  );
}
